import React from "react";
import { Sidebar } from "./Sidebar";
import { HomeContent } from "./HomeContent";
import { Footer } from "./Footer";

const Home = () => {
  return (
    <div>
      <Sidebar />
      <HomeContent />
      <Footer />
      <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
      <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
      <script type="text/javascript" src="javascript/index.js"></script>
    </div>
  );
};

export default Home;
